import { avatarUrl } from '@alternativamais/chat-core';
import { useState } from 'react';

import { ARQUIVOS } from '../config';
import {
  corDoAvatar,
  corDoStatus,
  iniciais,
  type StatusVisivel,
} from '@alternativamais/chat-core';
import { Icone } from './Icone';
import { noTamanho } from './imagens';

type Pessoa = {
  id: string;
  avatar: string | null;
  bot?: boolean;
};

/**
 * Foto da pessoa, ou as iniciais num círculo com a cor dela. A bolinha de
 * status fica no canto, com borda da cor do fundo onde o avatar está.
 */
export function Avatar({
  pessoa,
  nome,
  tamanho = 40,
  status,
  fundo = 'var(--cor-chat)',
  src,
}: {
  pessoa: Pessoa;
  nome: string;
  tamanho?: number;
  status?: StatusVisivel;
  /** Cor de onde o avatar está (borda da bolinha). */
  fundo?: string;
  /** Imagem no lugar da foto (prévia, avatar do servidor); nula = iniciais. */
  src?: string | null;
}) {
  const [falhou, setFalhou] = useState(false);
  const url = falhou
    ? null
    : src !== undefined
      ? src
      : avatarUrl(ARQUIVOS, pessoa);
  const bolinha = Math.max(10, Math.round(tamanho * 0.3));
  return (
    <span
      className="relative inline-flex shrink-0 select-none"
      style={{ width: tamanho, height: tamanho }}
    >
      {url ? (
        <img
          src={noTamanho(url, tamanho)}
          alt=""
          width={tamanho}
          height={tamanho}
          loading="lazy"
          onError={() => setFalhou(true)}
          className="h-full w-full rounded-full object-cover"
        />
      ) : (
        <span
          aria-hidden="true"
          className="flex h-full w-full items-center justify-center rounded-full font-semibold text-white"
          style={{
            background: pessoa.bot ? '#E67E22' : corDoAvatar(pessoa.id),
            color: pessoa.bot ? '#1A1206' : undefined,
            fontSize: Math.max(8, Math.round(tamanho * 0.38)),
          }}
        >
          {pessoa.bot ? (
            <Icone nome="robo" tamanho={Math.round(tamanho * 0.55)} />
          ) : (
            iniciais(nome)
          )}
        </span>
      )}
      {status && (
        <span
          aria-hidden="true"
          className="absolute rounded-full"
          style={{
            right: -3,
            bottom: -3,
            width: bolinha,
            height: bolinha,
            boxSizing: 'content-box',
            border: `3px solid ${fundo}`,
            background: status === 'offline' ? fundo : corDoStatus(status),
            boxShadow:
              status === 'offline'
                ? `inset 0 0 0 3px ${corDoStatus('offline')}`
                : undefined,
          }}
        />
      )}
    </span>
  );
}
